import "moment-timezone";
import React, { Component } from "react";
import { Button, Modal } from 'react-bootstrap';
import Field from '../Shared/Field';
import SetupCoachingPortalForm from './SetupCoachingPortalForm';


class SetupCoachingPortalModal extends Component {

  state = {}

  onSubmit = (deal, account_number, starts, ends) => {
    this.setState({ result: deal, starts: starts, ends: ends, account_number: account_number })
  }

  render() {
    const { deal, showModal, onCloseModal, onConfirmModal } = this.props
    const { result, account_number, starts, ends } = this.state
    if (!deal) return <span></span>

    return (
      <Modal show={showModal} onHide={onCloseModal} dialogClassName="modal-lg">
        <Modal.Header closeButton>
          <Modal.Title>Coaching</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {result && result.coaching ?
            <>
              <p>The account has been setup in the coaching portal</p>
              <p>Use the following links to setup the Weekly Call</p>

              <Field label='Account'><a href={`${result.coaching.book_weekly_call_url}&account_number=${account_number}&starts=${starts}&ends=${ends}`} target='coaching'>book weekly call</a></Field>

              <Field label='Account'><a href={result.coaching.account_url} target='coaching'>go to Account</a></Field>
              <Field label='Parent'><a href={result.coaching.parent_url} target='coaching'>go to Parent</a></Field>
              <Field label='Student'><a href={result.coaching.student_url} target='coaching'>go to Student</a></Field>

              <div>
                <Button onClick={() => onConfirmModal(result)} bsSize='small'>Close this window</Button>
              </div>
            </>
            :
            <SetupCoachingPortalForm deal={deal} onCancelSubmit={onCloseModal} onSubmit={this.onSubmit} />
          }
        </Modal.Body>
      </Modal>)
  }
}

export default SetupCoachingPortalModal